import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperGallery = () => {
  new Swiper('.swiper-gallery', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-gallery-button-next',
      prevEl: '.swiper-gallery-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });
};

export default swiperGallery;
